/**
 * Converts a string to a URL-friendly slug.
 */
const toSlug = (value: string) => {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

/**
 * Converts a string to title case, where the first letter of each word is capitalized.
 */
const toTitleCase = (value: string): string => {
  return value.replace(
    /\w\S*/g,
    (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase(),
  );
};

export { toSlug, toTitleCase };
